import type { RouteRecordRaw } from "vue-router";

const malawRoutes: RouteRecordRaw[] = [
  // Auth
  {
    path: "/dde",
    redirect: "/dde/login",
  },
  {
    path: "/dde/login",
    name: "MalawLogin",
    alias: ["/malaw/login"],
    component: () => import("@/views/malaw/auth/LoginView.vue"),
    meta: { public: true },
  },
  {
    path: "/malaw/inscriptions",
    name: "InscriptionsManagement",
    component: () => import("@/views/malaw/inscriptions/InscriptionsManagementView.vue"),
    meta: { requiresAuth: true, roles: ["SUPER_ADMIN", "ADMIN", "DIRECTEUR", "CHEF_BUREAU", "REPRESENTANT_HARAS_REGIONAL"] },
  },

  // Dashboard
  {
    path: "/malaw/dashboard",
    name: "MalawDashboard",
    component: () => import("@/views/malaw/dashboards/DashboardPage.vue"),
    meta: { requiresAuth: true },
  },

  // Chevaux
  {
    path: "/malaw/chevaux",
    name: "ChevauxList",
    component: () => import("@/views/malaw/chevaux/ChevauxListView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/chevaux/nouveau",
    name: "ChevalCreate",
    component: () => import("@/views/malaw/chevaux/ChevalCreateView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/chevaux/:id",
    name: "ChevalDetail",
    component: () => import("@/views/malaw/chevaux/ChevalDetailView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/chevaux/:id/modifier",
    name: "ChevalEdit",
    component: () => import("@/views/malaw/chevaux/ChevalEditView.vue"),
    meta: { requiresAuth: true },
  },

  // Saillies
  {
    path: "/malaw/saillies",
    name: "SailliesList",
    component: () => import("@/views/malaw/saillies/SailliesListView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/saillies/nouvelle",
    name: "SaillieCreate",
    component: () => import("@/views/malaw/saillies/SaillieCreateView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/saillies/:id",
    name: "SaillieDetail",
    component: () => import("@/views/malaw/saillies/SaillieDetailView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/saillies/:id/modifier",
    name: "SaillieEdit",
    component: () => import("@/views/malaw/saillies/SaillieEditView.vue"),
    meta: { requiresAuth: true },
  },

  // Registre saillies d'un étalon
  {
    path: "/malaw/chevaux/:id/registre-saillies",
    name: "RegistreSaillies",
    component: () => import("@/views/malaw/saillies/RegistreSailliesView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/chevaux/:id/cartes-identite",
    name: "CartesIdentiteManagement",
    component: () => import("@/views/malaw/chevaux/CartesIdentiteManagementView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/cartes-identite/generator",
    name: "CartesIdentiteGeneratorPage",
    component: () => import("@/views/malaw/chevaux/CartesIdentiteGeneratorPageV2.vue"),
    meta: { requiresAuth: true },
  },

  // Déclarations de naissance
  {
    path: "/malaw/declarations",
    name: "DeclarationsList",
    component: () => import("@/views/malaw/declarations/DeclarationsListView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/declarations/nouvelle",
    name: "DeclarationCreate",
    component: () => import("@/views/malaw/declarations/DeclarationCreateView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/declarations/:id",
    name: "DeclarationDetail",
    component: () => import("@/views/malaw/declarations/DeclarationDetailView.vue"),
    meta: { requiresAuth: true },
  },

  // Signalements
  {
    path: "/malaw/signalements",
    name: "SignalementsList",
    component: () => import("@/views/malaw/signalements/SignalementsListView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/signalements/nouveau",
    name: "SignalementCreate",
    component: () => import("@/views/malaw/signalements/SignalementCreateView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/signalements/:id",
    name: "SignalementDetail",
    component: () => import("@/views/malaw/signalements/SignalementDetailView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/signalements/:id/modifier",
    name: "SignalementEdit",
    component: () => import("@/views/malaw/signalements/SignalementEditView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/signalements/:id/carte",
    name: "CarteIdentite",
    component: () => import("@/views/malaw/signalements/CarteIdentiteView.vue"),
    meta: { requiresAuth: true },
  },

  // Haras Listing
  {
    path: "/malaw/haras/listing",
    name: "HarasListing",
    component: () => import("@/views/malaw/haras/HarasListingPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/haras/:numeroUnique",
    name: "HarasDetail",
    component: () => import("@/views/malaw/haras/HarasDetailPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/haras/:numeroUnique/chevaux",
    name: "HarasChevauxList",
    component: () => import("@/views/malaw/haras/HarasChevauxListPage.vue"),
    meta: { requiresAuth: true },
  },

  // Acteurs
  {
    path: "/malaw/acteurs/naisseurs",
    name: "NaisseursList",
    component: () => import("@/views/malaw/acteurs/NaisseurListView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/acteurs/veterinaires",
    name: "VeterinairesList",
    component: () => import("@/views/malaw/acteurs/VeterinaireListView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/acteurs/proprietaires",
    name: "ProprietairesList",
    component: () => import("@/views/malaw/acteurs/ProprietaireListView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/acteurs/haras",
    name: "HarasList",
    component: () => import("@/views/malaw/acteurs/HarasListView.vue"),
    meta: { requiresAuth: true },
  },

  // Qualification officielle
  {
    path: "/malaw/qualification",
    name: "QualificationList",
    component: () => import("@/views/malaw/qualification/QualificationListView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/qualification/:id",
    name: "QualificationForm",
    component: () => import("@/views/malaw/qualification/QualificationFormView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/chevaux/:id/agrements",
    name: "AgrementDetail",
    component: () => import("@/views/malaw/qualification/AgrementDetailView.vue"),
    meta: { requiresAuth: true },
  },

  // Demandes d'agrément
  {
    path: "/malaw/agrements",
    name: "DemandesList",
    component: () => import("@/views/malaw/agrements/DemandesListView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/agrements/nouvelle-demande",
    name: "DemandeCreate",
    component: () => import("@/views/malaw/agrements/DemandeCreateView.vue"),
    meta: { requiresAuth: true },
  },
  // Sessions d'agrément (ordre important : avant /:id)
  {
    path: "/malaw/agrements/sessions",
    name: "AgrementSessionsList",
    component: () => import("@/views/malaw/agrements/sessions/AgrementSessionsListView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/agrements/sessions/nouvelle",
    name: "AgrementSessionCreate",
    component: () => import("@/views/malaw/agrements/sessions/AgrementSessionCreateView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/agrements/sessions/:id",
    name: "AgrementSessionDetail",
    component: () => import("@/views/malaw/agrements/sessions/AgrementSessionDetailView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/agrements/annees-courantes",
    name: "AnneeCouranteList",
    component: () => import("@/views/malaw/agrements/annees-courantes/AnneeCouranteListView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/agrements/:id",
    name: "DemandeDetail",
    component: () => import("@/views/malaw/agrements/DemandeDetailView.vue"),
    meta: { requiresAuth: true },
  },
  // Sessions de Qualification (Commissions DDE) - ordre important!
  {
    path: "/malaw/sessions-qualification",
    name: "SessionsQualificationList",
    component: () => import("@/views/malaw/qualification/SessionsListView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/sessions-qualification/nouvelle",
    name: "SessionQualificationCreate",
    component: () => import("@/views/malaw/qualification/SessionCreateView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/sessions-qualification/:id/inscrire",
    name: "SessionInscrire",
    component: () => import("@/views/malaw/qualification/SessionInscrireView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/sessions-qualification/:id",
    name: "SessionQualificationDetail",
    component: () => import("@/views/malaw/qualification/SessionDetailView.vue"),
    meta: { requiresAuth: true },
  },

  // Page d'attente (user sans rôle métier)
  {
    path: "/malaw/en-attente",
    name: "EnAttente",
    component: () => import("@/views/malaw/auth/EnAttenteView.vue"),
    meta: { requiresAuth: true },
  },

  // Dashboard Directeur
  {
    path: "/malaw/directeur/demandes",
    name: "DirecteurDemandes",
    component: () => import("@/views/malaw/dashboards/DirecteurDashboard.vue"),
    meta: { requiresAuth: true, roles: ["DIRECTEUR", "ADMIN", "SUPER_ADMIN"] },
  },

  // Dashboard Chef Bureau
  {
    path: "/malaw/bureau/dashboard",
    name: "BureauDashboard",
    component: () => import("@/views/malaw/dashboards/BureauDashboard.vue"),
    meta: { requiresAuth: true, roles: ["CHEF_BUREAU", "ADMIN", "SUPER_ADMIN"] },
  },

  // Dashboard Vétérinaire
  {
    path: "/malaw/veterinaire/dashboard",
    name: "VeterinaireDashboard",
    component: () => import("@/views/malaw/dashboards/VeterinaireDashboard.vue"),
    meta: { requiresAuth: true, roles: ["VETERINAIRE", "SIGNALEUR_AGREE"] },
  },

  // Dashboard Naisseur
  {
    path: "/malaw/naisseur/dashboard",
    name: "NaisseurDashboard",
    component: () => import("@/views/malaw/dashboards/NaisseurDashboard.vue"),
    meta: { requiresAuth: true, roles: ["NAISSEUR", "RESPONSABLE_HARAS"] },
  },

  // Dashboard Propriétaire
  {
    path: "/malaw/proprietaire/mes-chevaux",
    name: "ProprietaireChevaux",
    component: () => import("@/views/malaw/dashboards/ProprietaireDashboard.vue"),
    meta: { requiresAuth: true, roles: ["PROPRIETAIRE"] },
  },

  // Dashboard Admin
  {
    path: "/malaw/admin/dashboard",
    name: "AdminDashboard",
    component: () => import("@/views/malaw/dashboards/AdminDashboard.vue"),
    meta: { requiresAuth: true, roles: ["ADMIN", "SUPER_ADMIN"] },
  },

  // Dashboard Signaleur
  {
    path: "/malaw/signaleur/dashboard",
    name: "SignaleurDashboard",
    component: () => import("@/views/malaw/dashboards/SignaleurDashboard.vue"),
    meta: { requiresAuth: true, roles: ["SIGNALEUR_AGREE"] },
  },

  // Dashboard Haras
  {
    path: "/malaw/haras/dashboard",
    name: "HarasDashboard",
    component: () => import("@/views/malaw/dashboards/HarasDashboard.vue"),
    meta: { requiresAuth: true, roles: ["RESPONSABLE_HARAS"] },
  },

  // Dashboard Étalonnier
  {
    path: "/malaw/etalonnier/dashboard",
    name: "EtallonnierDashboard",
    component: () => import("@/views/malaw/dashboards/EtallonnierDashboard.vue"),
    meta: { requiresAuth: true, roles: ["ETALONNIER"] },
  },

  // Dashboard DDE (Représentant Haras Régional)
  {
    path: "/malaw/dde/dashboard",
    name: "DDEDashboard",
    component: () => import("@/views/malaw/dashboards/DDEDashboard.vue"),
    meta: { requiresAuth: true, roles: ["REPRESENTANT_HARAS_REGIONAL", "ADMIN", "SUPER_ADMIN"] },
  },

  // Carnet de saillie
  {
    path: "/malaw/saillies/:id/carnet",
    name: "CarnetSaillie",
    component: () => import("@/views/malaw/saillies/CarnetSaillieView.vue"),
    meta: { requiresAuth: true },
  },

  // Identification Terrain (Agent DDE)
  {
    path: "/malaw/terrain/identification",
    name: "IdentificationTerrain",
    component: () => import("@/views/malaw/terrain/IdentificationTerrainView.vue"),
    meta: { requiresAuth: true, roles: ["CHEF_BUREAU", "REPRESENTANT_HARAS_REGIONAL", "DIRECTEUR", "ADMIN", "SUPER_ADMIN"] },
  },

  // Agréments de Production
  {
    path: "/malaw/agrements-production",
    name: "AgrementProduction",
    component: () => import("@/views/malaw/agrements/AgrementProductionView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/agrements-production/:id/cheval",
    name: "FicheChevalDemande",
    component: () => import("@/views/malaw/agrements/FicheChevalDemandeView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/agrements-production/:id/signer",
    name: "SignerDemande",
    component: () => import("@/views/malaw/agrements/SignerDemandeView.vue"),
    meta: { requiresAuth: true, roles: ["DIRECTEUR", "ADMIN", "SUPER_ADMIN"] },
  },

  // Configuration Signature Directeur
  {
    path: "/malaw/signature/configurer",
    name: "ConfigurerSignature",
    component: () => import("@/views/malaw/signature/ConfigurerSignatureView.vue"),
    meta: { requiresAuth: true, roles: ["DIRECTEUR", "ADMIN", "SUPER_ADMIN"] },
  },

  // Admin - Validation des Inscriptions
  {
    path: "/malaw/admin/pre-inscriptions",
    name: "AdminPreInscriptions",
    component: () => import("@/views/malaw/admin/PreInscriptionsView.vue"),
    meta: { requiresAuth: true, roles: ["SUPER_ADMIN", "ADMIN", "DIRECTEUR", "CHEF_BUREAU"] },
  },

  // Demandes de changement
  {
    path: "/malaw/demandes-changement",
    name: "DemandesChangementList",
    component: () => import("@/views/malaw/demandes-changement/DemandesChangementListView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/demandes-changement/nouvelle",
    name: "DemandeChangementCreate",
    component: () => import("@/views/malaw/demandes-changement/DemandeChangementCreateView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/demandes-changement/:id",
    name: "DemandeChangementDetail",
    component: () => import("@/views/malaw/demandes-changement/DemandeChangementDetailView.vue"),
    meta: { requiresAuth: true },
  },

  // Demandes de nationalité
  {
    path: "/malaw/demandes-nationalite",
    name: "DemandesNationaliteList",
    component: () => import("@/views/malaw/demandes-nationalite/DemandesNationaliteListView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/demandes-nationalite/nouvelle",
    name: "DemandeNationaliteCreate",
    component: () => import("@/views/malaw/demandes-nationalite/DemandeNationaliteCreateView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/malaw/demandes-nationalite/:id",
    name: "DemandeNationaliteDetail",
    component: () => import("@/views/malaw/demandes-nationalite/DemandeNationaliteDetailView.vue"),
    meta: { requiresAuth: true },
  },

  // Validation des documents
  {
    path: "/malaw/validation-documents",
    name: "ValidationDocuments",
    component: () => import("@/views/malaw/validation/ValidationDocumentsView.vue"),
    meta: { requiresAuth: true, roles: ["DIRECTEUR", "SUPER_ADMIN"] },
  },

  // Géniteurs externes (CRUD complet) — rôles admin uniquement (sans responsable haras public)
  {
    path: "/malaw/geniteurs-exterieurs",
    name: "GeniteursExternes",
    component: () => import("@/views/malaw/geniteurs/GeniteursExternesView.vue"),
    meta: { requiresAuth: true, roles: ["SUPER_ADMIN", "ADMIN", "DIRECTEUR", "CHEF_BUREAU"] },
  },
  {
    path: "/malaw/geniteurs-exterieurs/nouveau",
    name: "GeniteurExterieurCreate",
    component: () => import("@/views/malaw/geniteurs/GeniteurExterieurFormView.vue"),
    meta: { requiresAuth: true, roles: ["SUPER_ADMIN", "ADMIN", "DIRECTEUR", "CHEF_BUREAU"] },
  },
  {
    path: "/malaw/geniteurs-exterieurs/:id/modifier",
    name: "GeniteurExterieurEdit",
    component: () => import("@/views/malaw/geniteurs/GeniteurExterieurFormView.vue"),
    meta: { requiresAuth: true, roles: ["SUPER_ADMIN", "ADMIN", "DIRECTEUR", "CHEF_BUREAU"] },
  },
  {
    path: "/malaw/geniteurs-exterieurs/:id",
    name: "GeniteurExterieurDetail",
    component: () => import("@/views/malaw/geniteurs/GeniteurExterieurDetailView.vue"),
    meta: { requiresAuth: true, roles: ["SUPER_ADMIN", "ADMIN", "DIRECTEUR", "CHEF_BUREAU"] },
  },
];

export default malawRoutes;
